// extracted by mini-css-extract-plugin
export default {"input_search":"SearchBar_input_search__SZYIE","boton_search":"SearchBar_boton_search__atcrh"};